import axios from 'axios';
import { formatShortDateTime } from '../../utils/dates';

// Boutiques — the one place a Shopify / PrestaShop shop is connected. Mirrors
// Backend app/api/shops.py and app/services/shop_connections.py.

export const API = '/api/shops';

const authHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } });

export const list = () => axios.get(API, authHeaders());
export const create = (body) => axios.post(API, body, authHeaders());
export const update = (id, body) => axios.put(`${API}/${id}`, body, authHeaders());
export const test = (id) => axios.post(`${API}/${id}/test`, {}, authHeaders());
// Shopify: install (or re-authorize) the Unanimity app on the shop — Shopify's own page.
export const authorize = (id) => axios.post(`${API}/${id}/authorize`, {}, authHeaders());
export const syncOrders = (id) => axios.post(`${API}/${id}/sync`, {}, authHeaders());
export const remove = (id) => axios.delete(`${API}/${id}`, authHeaders());

export const fail = (error, fallback) => {
    const detail = error?.response?.data?.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
    return fallback;
};

// « 28 oct., 14:05 » — the shared short format (utils/dates, Paris time).
export const formatWhen = (value, lang) => formatShortDateTime(value, lang);

export const ORDER_USES = ['orders', 'notes', 'tracking'];
export const CATALOG_USES = ['products', 'prices'];
export const REQUIRES = { notes: 'orders', tracking: 'orders', prices: 'products' };

// The rights each use needs, as the shop's admin shows them (kept in step
// with SCOPES in shop_shopify.py and PERMISSIONS in shop_prestashop.py).
export const RIGHTS = {
    shopify: {
        orders: 'read_orders',
        notes: 'write_orders',
        tracking: 'write_merchant_managed_fulfillment_orders',
        products: 'read_products',
        prices: 'write_products',
    },
    prestashop: {
        orders: 'GET : orders, order_carriers, carriers, customers, addresses, countries, currencies, order_states',
        notes: 'GET + POST : customer_threads, customer_messages',
        tracking: 'GET + PUT + POST : order_carriers · POST : order_histories · GET : order_states',
        products: 'GET : products, stock_availables (combinations, categories, product_option_values si présents)',
        prices: 'GET + PUT : products',
    },
};
